import React from "react";
import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  const number = settings?.whatsapp_number || "2250711693161";
  const href = `https://wa.me/${number}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 bg-green-600 text-white p-4 rounded-full shadow-2xl whatsapp-pulse hover:scale-110 transition-transform"
      aria-label="Contact WhatsApp"
    >
      <MessageCircle size={26} strokeWidth={1.5} />
    </a>
  );
}
